import { notification, Spin } from 'antd'
import React, { createContext, useCallback, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useLocalStorage } from 'react-use'
import { post } from '../Common/api'
import { debounce } from '../Common/debounce'
import eventBus from '../Common/EventBus'

const LoginContext = createContext()
export default LoginContext

export const LoginContextProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage('user', { isAuth: false })
  const [loading, setLoading] = useState(false)
  const [eventOn, setEventOn] = useState(false)
  const [notificationApi, notificationContextHolder] = notification.useNotification()
  const navigate = useNavigate()

  const onNotAuthenticated = useCallback(debounce(() => {
    navigate('/login')
    logout()
  }, 100), [])

  useEffect(() => {
    if (eventOn) { return }
    setEventOn(true)
    eventBus.on('NOT_AUTHENTICATED', onNotAuthenticated)
    return () => {
      eventBus.remove('NOT_AUTHENTICATED', onNotAuthenticated)
    }
  }, [])

  const login = async (params) => {
    setLoading(true)
    await post({
      url: 'admin/login',
      params,
      notification: { api: notificationApi, state: 'login' },
      onSuccess: (response) => {
        const url = params.fabrication ? '/commands' : '/admin'
        setUser({ isAuth: true, ...response.user })
        notification.success({ message: response.message, placement: 'bottom' })
        window.location.href = url
      },
      onFailure: (response) => {
        notification.error({ message: response.error, placement: 'bottom' })
      }
    })
    setLoading(false)
  }

  const logout = () => {
    localStorage.clear()
  }

  const updatePassword = async (params) => {
    setLoading(true)
    await post({
      url: 'admin/users/update_password',
      params,
      notification: { api: notificationApi, state: 'password_update' },
      onSuccess: () => {
        navigate('/admin/login')
      }
    })
    setLoading(false)
  }

  const checkToken = async (params) => {
    setLoading(true)
    await post({
      url: 'admin/users/update_password',
      params,
      onSuccess: () => {},
      onFailure: (response) => {
        if (Object.keys(response.errors).includes('reset_password_token')) {
          notificationApi.error({ key: 'request_response', message: 'Lien expiré', placement: 'bottom' })
          navigate('/admin/login')
        }
      }
    })
    setLoading(false)
  }

  const values = {
    // localStorage
    user,
    setUser,

    // methods
    login,
    logout,
    updatePassword,
    checkToken
  }

  return <LoginContext.Provider value={values}>
    <Spin spinning={loading}>
      {notificationContextHolder}
      { children || <Outlet /> }
    </Spin>
  </LoginContext.Provider>
}
